import React, {useEffect, useState} from 'react';
import {WIDTH, LEFT_SPACE} from '../pianoroll/constants.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

export const useGridStyle = ({
    selectedPianoRollSteps,
    stepData,
    isAlternateColor,
    xScale,
    resolution,
    position,
    stepNumber,
    height,
    duration,
    color,
    isGuideStep
}) => {
    let isSelectedStep = selectedPianoRollSteps !== undefined 
        && selectedPianoRollSteps.indexOf(stepData) > -1;
    let width = xScale * WIDTH * resolution.numSteps() / 16;
    let unquantizedOffset = position * WIDTH * xScale;
    let left = stepNumber * WIDTH * xScale + unquantizedOffset;

    let style = {
        left: left,
        height: height,
        lineHeight: height + 'px',
        fontSize: Math.min(16, height) + 'px',
        width: stepData ? width * stepData.duration : width * duration,
        backgroundColor: isSelectedStep ? colors.brighten(color, 0.3) : color
    };

    if (isSelectedStep) {
        style.borderColor = color;
    } 

    let className = isAlternateColor ? "alternate " : "";
    className += isSelectedStep ? " selected " : "";

    if (isGuideStep) {
        className += " guide-step";
    }

    let slideStyle = {};
    if (!isGuideStep && stepData.slide) {
        slideStyle.borderLeftWidth = style.width - 2;
        slideStyle.borderBottomWidth = height * 0.8;
    }
    return {className, style, slideStyle};
};
